import { assertParamsPrescence } from '@kk/shared/utils/validators';
import { redirect, useRouteLoaderData } from 'react-router';
import type { RequestOpts } from '#/api/api-types';
import { getAllDocumentsQuery } from '#/api/hooks/useAllDocuments';
import { fetchSignDocumentQuery } from '#/api/hooks/useSignDocument';
import queryClient from '#/api/queryClient';
import { generateUrl } from '#/routes/utils/generateUrl';

export type LoaderData = Awaited<ReturnType<typeof loader>>;

export type Params = {
  documentId?: string;
};

export const id = 'signaturePage' as const;

async function loader({
  params,
  opts,
}: {
  params: Params;
  opts?: RequestOpts;
}) {
  assertParamsPrescence(params);
  const { documentId } = params;

  const signModel = await fetchSignDocumentQuery({ documentId }, opts);

  // If 204 response (already signed), the API returns undefined
  // Invalidate documents query and redirect to overview with success message
  if (!signModel) {
    await queryClient.invalidateQueries({
      queryKey: getAllDocumentsQuery().queryKey,
    });
    throw redirect(generateUrl('/underskriftsrum', {}, { signed: 'success' }));
  }

  return { signModel };
}

export const useSignaturePageLoaderData = () => useRouteLoaderData(id);

export default loader;
